export const POPOVER_CARET_SIZE = 16;
export const POPOVER_HALF_CARET_SIZE = POPOVER_CARET_SIZE / 2;
export const POPOVER_OFFSET = 3;
export function getScreenBounds() {
    const x = document.documentElement.clientLeft;
    const y = document.documentElement.clientTop;
    const width = document.documentElement.clientWidth - POPOVER_OFFSET * 2;
    const height = document.documentElement.clientHeight - POPOVER_OFFSET * 2;
    return {
        x,
        y,
        width,
        height,
    };
}
export function getBoundsFromDOMRect(domRect) {
    return {
        x: domRect.left,
        y: domRect.top,
        width: domRect.width,
        height: domRect.height,
    };
}
export function isPositionTop(position) {
    return position.startsWith('top');
}
export function isPositionBottom(position) {
    return position.startsWith('bottom');
}
export function isPositionRight(position) {
    return position.startsWith('right');
}
export function isPositionLeft(position) {
    return position.startsWith('left');
}
export function isSubPositionStart(position) {
    return position.endsWith('-start');
}
export function isSubPositionCenter(position) {
    return position.endsWith('-center');
}
export function isSubPositionEnd(position) {
    return position.endsWith('-end');
}
export function isPositionHorizontal(position) {
    return isPositionLeft(position) || isPositionRight(position);
}
export function isPositionVertical(position) {
    return isPositionTop(position) || isPositionBottom(position);
}
export function isFittingVertically(pos, trigger, screen) {
    return pos.y >= screen.y && pos.y + pos.height <= screen.height;
}
export function isFittingHorizontally(pos, trigger, screen) {
    return pos.x >= screen.x && pos.x + pos.width <= screen.width;
}
export function isBoundsInsideScreen(pos, trigger, screen) {
    return isFittingVertically(pos, trigger, screen) && isFittingHorizontally(pos, trigger, screen);
}
export function canAdjustPosition({ position, content, trigger, screen }) {
    if (isPositionVertical(position) && isFittingVertically(content, trigger, screen)) {
        content.x = content.x < screen.x ? screen.x : screen.width - content.width;
        return true;
    }
    if (isPositionHorizontal(position) && isFittingHorizontally(content, trigger, screen)) {
        content.y = content.y < screen.y ? screen.y : screen.height - content.height;
        return true;
    }
    return false;
}
